'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PORTAL_ID = null;

var PortalIdContainer = {
  get: function get() {
    return PORTAL_ID;
  },
  set: function set(portalId) {
    window.hubspot.portal.id = portalId;
    PORTAL_ID = Number(portalId);
  }
};

exports.default = PortalIdContainer;
module.exports = exports['default'];